import React from 'react';

import classes from './NotificationIcon.module.css';

import iconNotificationBlack from '../../assets/icons/notification-black.svg';

const notificationIcon = (props) => {
    return (
        <div className={classes.NotificationContainer}>
            {
                props.unreadNotifCount <= 0 ? null :
                    <span className={[classes.NotificationCount, props.countChanged ? classes.Ripple : ''].join(' ')} onClick={props.onNotificationIconClick}>{props.unreadNotifCount}</span>
            }
            <img
                onClick={props.onNotificationIconClick}
                className={classes.NotificationIcon}
                alt="Notification Icon"
                src={iconNotificationBlack}
            />
        </div>
    );
}

export default notificationIcon;